import { render, staticRenderFns } from "./OptimalPostsPlanning.vue?vue&type=template&id=0db2b2c6&"
import script from "./OptimalPostsPlanning.vue?vue&type=script&lang=js&"
export * from "./OptimalPostsPlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports